import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain, focusVisibleOutline, withFocusVisible } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isFocusVisible: boolean
}

export const Button = withFocusVisible(styled(ButtonPlain)<Props>`
	display: flex;
	align-items: center;
	column-gap: 10px;
	padding: 12px;
	width: 100%;
	position: relative;
	background-color: transparent;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.color.input.border};
	transition:
		background-color 0.15s ease-in-out,
		border-color 0.15s ease-in-out;

	${focusVisibleOutline(helpers.color.link)}

	&:hover,
	&:focus-visible {
		background-color: ${({ theme }) => transparentize(0.92, theme.color.primary)};
		border-color: ${({ theme }) => theme.color.primary};
	}
`)
